module.exports = __webpack_public_path__ + "img/bannerabout.081784cb.png";